import { Inject, Injectable } from "@angular/core";
import { StatusCodeService } from "@obg/ngx.core";
import { StatusCodes } from "@obg/ngx.global";
import { Response } from "express";

import { RESPONSE_TOKEN } from "../model";

@Injectable()
export class ServerStatusCodeService implements StatusCodeService {
	constructor(@Inject(RESPONSE_TOKEN) private response: Response) {}

	setStatusCode(statusCode: StatusCodes, description?: string): void {
		this.response.status(statusCode);
		if (description) {
			this.response.header("x-obg-status-description", description);
		}
	}
}
